import React from 'react'
import { CSSTransition } from 'react-transition-group'

export default function ListItem({
  children,
  show,
  text,
  title,
}) {
  return (
    <CSSTransition
      in={show}
      classNames="fade"
      timeout={600}
      unmountOnExit
    >
      <div className="bg-black-o-50 bottom-0 fixed left-0 overflow-y-auto right-0 top-0 z5">
        <div className="center flex flex-center flex-justify-center mh-100vh p3 sm-p0">
          <div className="bg-white p4 rounded-16" style={{ maxWidth: 600 }}>
            {title && <h2 className="bold h2 mb2">{title}</h2>}

            {text && <p className="mb3">{text}</p>}

            {children}
          </div>
        </div>
      </div>
    </CSSTransition>
  )
}
